import React, { useState } from "react";
import LegalFooterBannerAndLinks from "components/legal/LegalFooterBannerAndLinks";
import LegalPagesBrandHeader from "components/legal/LegalPagesBrandHeader";

const faqItems = [
  {
    question: "What is AlphaSniper.io?",
    answer:
      "AlphaSniper.io is an automated copy trading system that mirrors professional trades on your own account in real time.",
  },
  {
    question: "How does automatic copy trading work on AlphaSniper?",
    answer:
      "After connecting your trading account, AlphaSniper automatically replicates eligible trades based on our strategy and risk settings, without manual execution.",
  },
  {
    question: "Do I keep control of my account and funds?",
    answer:
      "Yes. You keep full control of your account and capital at all times. AlphaSniper is designed to execute strategy logic, not to take ownership of your funds.",
  },
  {
    question: "Is AlphaSniper suitable for beginners?",
    answer:
      "Yes. The platform is beginner-friendly, with a guided setup and clear steps so users can start copy trading without advanced technical knowledge.",
  },
  {
    question: "What are the main risks of copy trading?",
    answer:
      "Copy trading involves market risk and losses are possible. Past performance never guarantees future results, so you should only trade with capital you can afford to risk.",
  },
  {
    question: "Can I stop or pause copy trading anytime?",
    answer:
      "Yes. You can pause, adjust, or stop your copy trading configuration whenever you want from your AlphaSniper dashboard.",
  },
  {
    question: "How do I start with AlphaSniper.io?",
    answer:
      "Create your account, buy a slot, connect your trading account, and your account will be activated.",
  },
  {
    question: "What is the minimum deposit required for the system to work?",
    answer:
      "Minimum required Leverage 1:1000 = USD 200.",
  },
  {
    question: "Do you offer refunds on AlphaSniper subscriptions?",
    answer:
      "Yes, only for the first month, and only if:\n• You use an AlphaSniper-designated broker partner account, opened and maintained per our Refund Policy (this is required to be eligible for the first-month guarantee).\n• At the end of that month your final balance is lower than your initial balance.\n• All trading activity on the account is fully automatic and there are no manual trades on that account.\n• After you complete your first month and once all trades are closed.\n• If you still have open trades at the end of the month, your subscription is not deactivated until those trades are closed.",
  },
  {
    question: "How long do I have to request a refund?",
    answer:
      "After you complete your first month and submit the refund form, our team will investigate your request and reply as soon as possible.",
  },
  {
    question: "Are all payments refundable?",
    answer:
      "No. Some fees or specific service conditions may be non-refundable. Each case is reviewed under the refund rules published by AlphaSniper.",
  },
  {
    question: "When will I receive my refund after approval?",
    answer:
      "After approval, refunds are typically processed within a few business days. The final timing depends on your payment provider or card issuer.",
  },
  {
    question: "Will performance losses be refunded?",
    answer:
      "No. Trading losses are market-related and are not considered refundable service charges.",
  },
  {
    question: "Can I cancel now and avoid future charges?",
    answer:
      "Yes. You can cancel your subscription to stop upcoming renewals. Cancellation does not automatically guarantee a refund for past payments.",
  },
  {
    question: "Where can I read the full refund terms?",
    answer:
      "You can read the complete terms on our dedicated Refund Policy page, which is the official reference for all refund decisions. That page also lists verification links for designated broker partner onboarding where applicable.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <main className="min-h-screen bg-[#0B1437] px-5 py-6 text-white sm:py-8">
      <div className="mx-auto w-full max-w-5xl">
        <LegalPagesBrandHeader />
        <header className="mb-5 space-y-2 text-center">
          <h1 className="text-3xl font-bold sm:text-4xl">
            Frequently Asked Questions
          </h1>
          <p className="mx-auto max-w-3xl text-sm leading-relaxed text-gray-300 sm:text-base">
            Everything you need to know about AlphaSniper copy trading,
            subscriptions, and refund-related requests.
          </p>
        </header>

        <section className="space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <article
                key={item.question}
                className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04]"
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => toggleItem(index)}
                >
                  <span className="text-sm font-semibold text-white sm:text-base">
                    {item.question}
                  </span>
                  <span className="text-brand-300">{isOpen ? "−" : "+"}</span>
                </button>

                {isOpen && (
                  <div className="border-t border-white/10 px-5 pb-4 pt-3">
                    <p className="whitespace-pre-line text-sm leading-relaxed text-gray-300 sm:text-base">
                      {item.answer}
                    </p>
                  </div>
                )}
              </article>
            );
          })}
        </section>

        <footer className="mt-8 border-t border-white/10 pt-5 text-center text-xs text-gray-400 sm:text-sm">
          <p>AlphaSniper 2026 © All Rights Reserved</p>
          <LegalFooterBannerAndLinks />
        </footer>
      </div>
    </main>
  );
}
